import styled from "styled-components";
export const ModalContentWrapperDiv = styled.div`
  .modal-header {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .modal-body {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  }
  .stepperStyle {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  }
  .stepperStyle .MuiStepper-alternativeLabel {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  }
  .addWorkNav {
    background-image: linear-gradient(
      30deg,
      ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"} 0%,
      ${({ theme }) => theme.colors.themePrimaryDarker || "#004AA0"} 100%
    ) !important;
  }
`;

export const UserBulkUploadModal = styled.div`
  background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
  .modal-title {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .bulkTable table thead {
    background-color: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  }
  .bulkTable table thead tr th {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .table td,
  .table th {
    padding: 0.5rem;
    vertical-align: top;
    border-top: 1px solid ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  }
  td.respo_bulk_a,
  td.respo_bulk_b {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  td.respo_bulk_c svg .cls-1 {
    fill: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  }
  .bulkTable table tbody {
    border: 1px solid ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  }
  .custom-file label svg {
    fill: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .uploadStyleCode {
    background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
    border: 2px solid ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"} !important;
  }
  .uploadStyleCode span.font-weight-bolder {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .uploadStyleCode span {
    color: ${({ theme }) => theme.colors.grayL4 || "#9A9A9A"};
  }
  .table_TD table th {
    background: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  }
  .table-striped tbody tr:nth-of-type(odd) td {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }
  .table-striped tbody tr:nth-of-type(odd) div svg .cls-1 {
    fill: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  }
  p.elipsis_asset {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
  }
  .bulk_information_header_white {
    background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
  }
`;

export const UserPanelStyled = styled.div`
  .assetMobileCss {
    background-color: ${({ theme }) => theme.colors.themePrimary || "#0d5fbe"};
  }
  .filterButtonCss {
    background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
    border: 1px solid ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"};
  }
`;

export const FilterIconStyled = styled.div`
  font-size: 20px !important;
  color: ${({ theme }) => theme.colors.themePrimary || "#0d5fbe"};
  position: relative;
  top: 3px;
`;

export const DesktopView = styled.div`
  @media (max-width: 768px) {
    display: none !important;
  }
`;

export const MobileView = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const ButtonsContainer = styled.div`
  display: block;
  float: left;
  width: 100%;
  text-align: left;
  /* margin: 10px 0px;*/

  button {
    margin-right: 10px;
  }
`;

export const ActionBarWrapper = styled.div`
  position: relative;
`;
export const ActionBarButtons = styled.div`
  position: absolute;
  z-index: 5;
  width: 100%;
  background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 37%);
  -webkit-box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 37%);
  -moz-box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 37%);
  display: block;
  button {
    border: 0px;
    display: block;
    width: 100%;
    float: left;
    text-align: left;
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
    text-transform: capitalize;
    font-size: 16px;
    font-family: "Open Sans";
    i {
      display: none;
    }
  }
`;

export const SearchBoxWrapper = styled.div`
  flex: 1;
`;

export const SearchFilter = styled.div`
  display: flex;
`;
export const FilterWrapper = styled.div`
  flex: 0;
`;

export const CloseBackDiv = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayL1 || "#323232"};
  border-radius: 4px;
  margin-left: 10px;
  height: 36px;
  width: 42px;
  align-items: center;
  justify-content: center;
  display: flex;
  background: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
`;
export const FilterBackDiv = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayL1 || "#323232"};
  border-radius: 4px;
  margin-left: 10px;
  height: 36px;
  width: 42px;
  align-items: center;
  justify-content: center;
  display: flex;
`;
export const FilterIconDiv = styled.div`
  font-size: 20px !important;
  display: flex;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
`;

export const CloseIconDiv = styled.div`
  font-size: 20px !important;
  display: flex;
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
`;

export const FilterOnclickDes = styled.div``;
export const FilterDesWrapper = styled.div`
  margin-bottom: 10px;
  @media (max-width: 1100px) {
    .col {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;

export const UserMobileListWrapper = styled.div`
  .tableHeight {
    max-height: calc(100vh - 260px);
    overflow-y: auto;
    height: auto;
    @media (max-width: 768px) {
      max-height: calc(100vh - 360px);
    }
  }
`;

export const UserTypeDetailHeading = styled.div`
  text-align: left;
  float: left;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  line-height: 45px;
  padding-left: 9px;
  font-size: 16px !important;
  font-weight: 500;
  border-radius: 4px;
  font-family: "Open Sans", sans-serif;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;

  span {
    font-weight: 500;
  }

  img {
    margin-right: 8px;
    margin-left: 8px;
  }
`;

export const RightIconImage = styled.div`
  /* font-size: 20px !important; */
  display: inline;
  line-height: 12px;
  margin-left: 5px;
  margin-right: 5px;
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
`;